// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__3-qjB","title":"Home_title__1ks5w","carg":"Home_carg__kwiq6","az":"Home_az__j2PHT","rick":"Home_rick__KI-c9"};